import * as React from 'react';

import DubbingLanguageContext from 'bundles/unified-description-page-common/contexts/DubbingLanguageContext';
import {
  getAudienceLanguageCode,
  previewXdpAiDubbingVariant,
} from 'bundles/unified-description-page-common/utils/dubbingUtil';

const DubbingLanguageProvider = ({ children }: { children: React.ReactNode }) => {
  // TODO: hook up backend API to query dubbing language codes
  // https://coursera.atlassian.net/browse/MERCH-1117
  return (
    <DubbingLanguageContext.Provider
      value={{
        loading: false,
        dubbingLanguageCodes: previewXdpAiDubbingVariant() ? ['fr', 'de', 'es'] : null,
        userLanguageCode: getAudienceLanguageCode(),
      }}
    >
      {children}
    </DubbingLanguageContext.Provider>
  );
};

export default DubbingLanguageProvider;
